/* eslint camelcase: 0 */

// El + "" fuerza la conversión a texto que espera la API de serial.

export const serial_print = (block, generator) => {
  const content = (generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  return `serial.writeString(${content} + "");\n`;
};

export const serial_println = (block, generator) => {
  const content = (generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  return `serial.writeLine(${content} + "");\n`;
};
